import { ICON_CALENDAR } from "common/constants";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

const PersonItem = ({ data, index }: { data: any; index: number }) => {
  const details = [
    data.gender && `<span class="fw-medium">Gender:</span> ${data.gender}`,
    data.firstName &&
      `<span class="fw-medium">First Name:</span> ${data.firstName}`,
    data.middleName &&
      `<span class="fw-medium">Middle Name:</span> ${data.middleName}`,
    data.surname && `<span class="fw-medium">Surname:</span> ${data.surname}`,
    data.dateOfBirth &&
      `<span class="fw-medium">Date of Birth:</span> ${data.dateOfBirth}`,
    data?.alias && `<span class="fw-medium">Alias Names:</span> ${data.alias}`,
    data?.currentNationality?.name &&
      `<span class="fw-medium">Current Nationality:</span> ${data.currentNationality.name}`,
    data?.nationalityAtBirth?.name &&
      `<span class="fw-medium">Nationality at Birth:</span> ${data.nationalityAtBirth.name}`,
    data?.phoneNumbers?.length > 0 &&
      `<span class="fw-medium">Phone Number:</span> ${data.phoneNumbers[0].number}`,
    data?.emails?.length > 0 &&
      `<span class="fw-medium">Email:</span> ${data.emails[0].email}`,
    data?.physicalAddress?.length > 0 &&
      `<span class="fw-medium">Physical Address:</span> ${data.physicalAddress[0].address}`,
    data?.contractorAffiliations?.length > 0 &&
      `<span class="fw-medium">Contractor Affiliations:</span> Exists`,
  ].filter(Boolean);

  const detailsString = useMemo(() => details.join(", "), [details]);
  const componentId = React.useMemo(
    () =>
      `person-item-${data?.id || Math.random().toString(36).substring(2, 9)}`,
    [data?.id]
  );

  return (
    <div className={index === 0 ? "pb-3" : "py-3"} id={componentId}>
      <style>
        {`
          #${componentId} em {
            background-color: #fff59d;
            font-style: normal;
            padding: 0 0px;
            border-radius: 2px;
            font-weight: 500;
          }
        `}
      </style>
      <h5 className="mb-1">
        <Link to={`/persons/${data.id}`}>
          <span
            dangerouslySetInnerHTML={{ __html: data?.fullName || "" }}
          ></span>
        </Link>
      </h5>
      <p className="text-success mb-2">
        <span className="me-2">Person</span>
        {data?.semgMentions && data?.semgMentions?.length > 0 && (
          <span className="badge bg-warning-subtle text-warning fs-11 me-2">
            SEMG Mention
          </span>
        )}
      </p>
      <p
        className="text-muted mb-2"
        dangerouslySetInnerHTML={{ __html: `... ${detailsString} ...` }}
      ></p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">12 Feb 2024</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default PersonItem;
